module.exports = __webpack_public_path__ + "img/audience-manager-color.a6193f8d.svg";